import React, { useState, useEffect } from "react";
import styles from "./UserContent.module.css";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "@_actions/user.actions";
import userStates from "@_configs/userStates.config";
import classnames from "classnames";
import AreYouSurePopup from "@_components/popups/AreYouSurePopup/AreYouSurePopup";
import CheckBox from "@_components/CheckBox/CheckBox";
import TextfieldInput from "@_components/TextfieldInput/TextfieldInput";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import PersonIcon from "@mui/icons-material/Person";
import { getUserDataFromJwt, isNull, validateEmail } from "@_utils/helpers";

function UserContent() {
  const jwtData = getUserDataFromJwt();
  const dispatch = useDispatch();

  const userReducer = useSelector((state) => state.userReducer);

  const [openAreYouSurePopup, setOpenAreYouSurePopup] = useState(false);
  const [userDetails, setUserDetails] = useState({
    name: (userReducer.selected_user && userReducer.selected_user.name) || "",
    public_name:
      (userReducer.selected_user && userReducer.selected_user.public_name) ||
      "",
    email: (userReducer.selected_user && userReducer.selected_user.email) || "",
    role:
      (userReducer.selected_user && userReducer.selected_user.role) || "AGENT",
    receive_unread_emails_notifications:
      userReducer.selected_user?.receive_unread_emails_notifications != null
        ? Boolean(userReducer.selected_user.receive_unread_emails_notifications)
        : true,
    receive_payment_notifications:
      userReducer.selected_user?.receive_payment_notifications != null
        ? Boolean(userReducer.selected_user.receive_payment_notifications)
        : true,
  });

  useEffect(() => {
    setUserDetails({
      name: (userReducer.selected_user && userReducer.selected_user.name) || "",
      public_name:
        (userReducer.selected_user && userReducer.selected_user.public_name) ||
        "",
      email:
        (userReducer.selected_user && userReducer.selected_user.email) || "",
      role:
        (userReducer.selected_user && userReducer.selected_user.role) ||
        "AGENT",
      receive_unread_emails_notifications:
        userReducer.selected_user?.receive_unread_emails_notifications != null
          ? Boolean(
              userReducer.selected_user?.receive_unread_emails_notifications
            )
          : true,
      receive_payment_notifications:
        userReducer.selected_user?.receive_payment_notifications != null
          ? Boolean(userReducer.selected_user?.receive_payment_notifications)
          : true,
    });
  }, [userReducer.selected_user]);

  const [btnPressed, setBtnPressed] = useState(false);

  function handleInputChange(e) {
    const { name, value } = e.target;
    setUserDetails((userDetails) => ({
      ...userDetails,
      [name]: value,
    }));
  }
  const handleAddNewUser = () => {
    setBtnPressed(true);

    let data = {
      ...userDetails,
      role: !userDetails.role ? "AGENT" : userDetails.role.toUpperCase(),
    };

    dispatch(userActions.addUser(data));
  };

  const handleCloseNewUser = () => {
    dispatch(userActions.addUserState(false));
  };

  const handleDeactivateUser = () => {
    dispatch(userActions.deactivateUser(userReducer.selected_user.user_id));
  };

  const handleActivateUser = () => {
    dispatch(userActions.activateUser(userReducer.selected_user.user_id));
  };

  const handleUpdateUser = () => {
    setBtnPressed(true);

    let data = {
      ...userDetails,
      role: !userDetails.role ? "AGENT" : userDetails.role.toUpperCase(),
    };
    dispatch(userActions.updateUser(userReducer.selected_user.user_id, data));
  };

  const handleDeleteUser = () => {
    dispatch(userActions.deleteUser(userReducer.selected_user.user_id));
  };

  useEffect(() => {
    if (
      userReducer.status.USER_ACTIVATE_PUT === "success" ||
      userReducer.status.USER_DEACTIVATE_PUT === "success"
    ) {
      let updatedSelectedUser = userReducer.users.list.filter(
        (user) => user.user_id === userReducer.selected_user.user_id
      );
      dispatch(userActions.selectUser(updatedSelectedUser[0]));
    }
  }, [
    userReducer.status.USER_ACTIVATE_PUT,
    userReducer.status.USER_DEACTIVATE_PUT,
    userReducer.users.list,
    userReducer.selected_user,
    dispatch,
  ]);

  useEffect(() => {
    if (userReducer.status.USER_DELETE === "success") {
      dispatch(userActions.selectUser());
    }
  }, [userReducer.status.USER_DELETE, dispatch]);

  return (
    <div className={styles.root}>
      <div
        className={
          (userReducer.add_user_state && styles.user_header) ||
          (userReducer.selected_user &&
            userReducer.selected_user.state &&
            userReducer.selected_user.state === "DEACTIVATED" &&
            classnames(styles.user_header, styles.user_header_deactivated)) ||
          (userReducer.selected_user &&
            userReducer.selected_user.state &&
            userReducer.selected_user.state === "INVITATION_PENDING" &&
            classnames(styles.user_header, styles.user_header_pending)) ||
          (userReducer.selected_user &&
            userReducer.selected_user.state &&
            userReducer.selected_user.state === "ACTIVE" &&
            classnames(styles.user_header))
        }
      >
        <div className={styles.user_name_container}>
          <div className={styles.icon_container}>
            {(userReducer.selected_user &&
              userReducer.selected_user.state &&
              userStates[userReducer.selected_user.state].icon) || (
              <PersonIcon />
            )}

            <div>
              {(userReducer.selected_user &&
                userReducer.selected_user.role &&
                userReducer.selected_user.role.toLowerCase()) ||
                (!userDetails.role && "AGENT") ||
                userDetails.role.toLowerCase()}
            </div>
          </div>
          <h2>
            {(userReducer.selected_user && userReducer.selected_user.name) ||
              "New User"}
          </h2>
        </div>
        {userReducer.selected_user &&
          userReducer.selected_user.state === "INVITATION_PENDING" && (
            <Button
              className={styles.btn_delete}
              onClick={() => setOpenAreYouSurePopup(true)}
            >
              Delete User
            </Button>
          )}
        {userReducer.selected_user &&
          userReducer.selected_user.state === "ACTIVE" &&
          jwtData.user_id !== userReducer.selected_user.user_id && (
            <Button
              className={styles.btn_delete}
              onClick={() => handleDeactivateUser()}
            >
              Deactivate User
            </Button>
          )}
        {userReducer.selected_user &&
          userReducer.selected_user.state === "DEACTIVATED" && (
            <Button
              className={styles.btn_delete}
              onClick={() => handleActivateUser()}
            >
              Activate User
            </Button>
          )}
      </div>
      <div className={styles.content_container}>
        <div>
          {userReducer.add_user_state && (
            <div className={styles.label}>
              <p>* Required Fields</p>
            </div>
          )}
        </div>

        <>
          {/* 2-Column Inputs */}
          <div className={styles.columns_wrapper}>
            {/* Left column */}
            <div className={styles.column_container}>
              <TextfieldInput
                label="Name"
                placeholder="Name"
                onChange={handleInputChange}
                name="name"
                value={userDetails.name}
                required
                error={btnPressed && isNull(userDetails.name)}
                disabled={
                  userReducer.selected_user &&
                  userReducer.selected_user.state === "DEACTIVATED"
                }
              />
              <TextfieldInput
                label="Email"
                placeholder="Email"
                onChange={handleInputChange}
                name="email"
                value={userDetails.email}
                required
                disabled={
                  userReducer.selected_user && userReducer.selected_user.email
                }
                error={
                  btnPressed &&
                  (isNull(userDetails.email) ||
                    !validateEmail(userDetails.email))
                }
              />
            </div>

            {/* Right column */}
            <div className={styles.column_container}>
              <TextfieldInput
                label="Public Name"
                placeholder="Public Name"
                onChange={handleInputChange}
                name="public_name"
                value={userDetails.public_name}
                required
                error={btnPressed && isNull(userDetails.public_name)}
                disabled={
                  userReducer.selected_user &&
                  userReducer.selected_user.state === "DEACTIVATED"
                }
              />
              <TextfieldInput
                select
                label="Role"
                placeholder="Role"
                onChange={handleInputChange}
                defaultValue="AGENT"
                name="role"
                value={userDetails.role}
                required
                disabled={
                  userReducer.selected_user &&
                  userReducer.selected_user.state === "DEACTIVATED"
                }
              >
                <MenuItem value="ADMIN">Admin</MenuItem>
                <MenuItem value="AGENT">Agent</MenuItem>
              </TextfieldInput>
            </div>
          </div>

          {/* Bottom Row: Checkboxes + Save Button */}
          <div className={styles.bottom_row_container}>
            <div className={styles.checkbox_group}>
              <CheckBox
                name="paymentNotifications"
                label="Notify the user about received payments."
                checked={userDetails.receive_payment_notifications}
                onChange={(e) =>
                  setUserDetails((prev) => ({
                    ...prev,
                    receive_payment_notifications: e.target.checked,
                  }))
                }
              />
              <CheckBox
                name="emailNotifications"
                label="Notify the user about unread emails"
                checked={userDetails.receive_unread_emails_notifications}
                onChange={(e) =>
                  setUserDetails((prev) => ({
                    ...prev,
                    receive_unread_emails_notifications: e.target.checked,
                  }))
                }
              />
            </div>
            {userReducer.selected_user &&
              (userReducer.selected_user.state === "INVITATION_PENDING" ||
                userReducer.selected_user.state === "ACTIVE") && (
                <div className={styles.save_button_container}>
                  <Button
                    className={styles.btn_save}
                    onClick={handleUpdateUser}
                  >
                    Save
                  </Button>
                </div>
              )}
            {userReducer.add_user_state && (
              <div className={styles.btn_container}>
                {userReducer.add_user_state && (
                  <Button
                    className={styles.btn_cancel}
                    onClick={() => handleCloseNewUser()}
                  >
                    Cancel
                  </Button>
                )}

                <div>
                  {userReducer.add_user_state && (
                    <Button
                      className={styles.btn_save_and_send_invite}
                      onClick={() => handleAddNewUser()}
                    >
                      Save and send invitation
                    </Button>
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      </div>
      <AreYouSurePopup
        open={openAreYouSurePopup}
        close={() => setOpenAreYouSurePopup(false)}
        onClick={handleDeleteUser}
      >
        Are you sure you want to delete this user?
      </AreYouSurePopup>
    </div>
  );
}

export default UserContent;
